import { Component, OnInit, Input, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import * as d3 from "d3";
import $ from "jquery";

@Component({
  selector: 'app-line-graph',
  templateUrl: './line-graph.component.html',
  styleUrls: ['./line-graph.component.scss']
})
export class LineGraphComponent implements OnInit {

  constructor(private el: ElementRef) { }

  @Input() examWiseMarks: any;
  @Input() width: number;
  @Input() height: number;
  @Input() paddingLeft: number = 5;
  @Input() paddingRight: number = 5;
  @Input() paddingTop: number = 5;
  @Input() paddingBottom: number = 5;
  @Input() circleRadius: number = 4;
  @Input() enableClick: boolean;
  @ViewChild('graph', { static: true }) svg: ElementRef;

  ngOnInit() {
    this.drawGraph();
  }

  drawGraph() {

    var x = d3.scaleLinear().range([this.paddingLeft, this.width - this.paddingRight])
      .domain([0, d3.max(this.examWiseMarks, function (d, i) { return i; })]);
    var y = d3.scaleLinear().range([this.height - 5, this.paddingTop])
      .domain([0, 100]);

    var avgBezierLine = d3.line()
      .x(function (d, i) { return x(i); })
      .y(function (d: any) { return y(d.class_average); })
      .curve(d3.curveCatmullRom);

    var topperBezierLine = d3.line()
      .x(function (d, i) { return x(i); })
      .y(function (d: any) { return y(d.class_topper); })
      .curve(d3.curveCatmullRom);

    var examBezierLine = d3.line()
      .x(function (d, i) { return x(i); })
      .y(function (d: any) { return y(d.marks); })
      .curve(d3.curveCatmullRom);


    var svg = d3.select(this.svg.nativeElement)
      .append("svg")
      .attr("viewBox", "0 0 " + this.width + " " + this.height);

    var toolTip = d3.select("body")
      .select("#tooltipDiv");

    svg.append('path')
      .attr("d", avgBezierLine(this.examWiseMarks))
      .attr("stroke", "#bdc1d4")
      .attr("stroke-width", 1)
      .attr("stroke-dasharray", "2, 2")
      .attr("fill", "none");

    svg.append('path')
      .attr("d", topperBezierLine(this.examWiseMarks))
      .attr("stroke", "rgba(241, 205, 124, 0.9)")
      .attr("stroke-width", 1)
      .attr("stroke-dasharray", "2, 2")
      .attr("fill", "none");

    svg.append('path')
      .attr("d", examBezierLine(this.examWiseMarks))
      .attr("stroke", "#535aff")
      .attr("stroke-width", 1)
      .attr("fill", "none")
      .attr("class", "studentPath");


    svg.append("g")
      .selectAll("circle")
      .data(this.examWiseMarks)
      .enter()
      .append("circle")
      .attr("r", this.circleRadius)
      .attr("cx", function (d, i) { return x(i); })
      .attr("cy", function (d: any) { return y(d.class_average); })
      .attr("fill", "#bdc1d4")
      .on("mouseover", function (d: any) {
        toolTip.transition()
          .duration(200)
          .style("opacity", 1);
        toolTip.html(
          "<p>Class Avg</p>" +
          "<strong>" + (Math.round(d.class_average * 100) / 100).toString() + "%" + "</strong>" +
          "<p>" + d.exam + "</p>"
        )
          .style("left", (d3.event.pageX) + "px")
          .style("top", (d3.event.pageY - 28) + "px");
      })
      .on("mouseout", function (d) {
        toolTip.transition()
          .duration(500)
          .style("opacity", 0);
      });

    svg.append("g")
      .selectAll("circle")
      .data(this.examWiseMarks)
      .enter()
      .append("circle")
      .attr("r", this.circleRadius)
      .attr("cx", function (d, i) { return x(i); })
      .attr("cy", function (d: any) { return y(d.class_topper); })
      .attr("fill", "rgba(241, 205, 124, 0.9)")
      .on("mouseover", function (d: any) {
        toolTip.transition()
          .duration(200)
          .style("opacity", .9);
        toolTip.html(
          "<p>Topper</p>" +
          "<strong>" + (Math.round(d.class_topper * 100) / 100).toString() + "%" + "</strong>" +
          "<p>" + d.exam + "</p>")
          .style("left", (d3.event.pageX) + "px")
          .style("top", (d3.event.pageY - 28) + "px");
      })
      .on("mouseout", function (d) {
        toolTip.transition()
          .duration(500)
          .style("opacity", 0);
      });

    var click = this.enableClick;
    svg.append("g")
      .selectAll("circle")
      .data(this.examWiseMarks)
      .enter()
      .append("circle")
      .attr("r", this.circleRadius)
      .attr("cx", function (d, i) { return x(i); })
      .attr("cy", function (d: any) { return y(d.marks); })
      .attr("fill", "#ffffff")
      .attr("stroke", "#535aff")
      .attr("stroke-width", "1")
      .on("mouseover", function (d: any) {
        toolTip.transition()
          .duration(200)
          .style("opacity", .9);
        toolTip.html(
          "<strong>" + (Math.round(d.marks * 100) / 100).toString() + "%" + "</strong>" +
          "<p>" + d.exam + "</p>")
          .style("left", (d3.event.pageX) + "px")
          .style("top", (d3.event.pageY - 28) + "px");
      })
      .on("mouseout", function (d) {
        toolTip.transition()
          .duration(500)
          .style("opacity", 0);
      })
      .on("click", function (d) {
        if (click == true) {
          window.open("/Student/#/pages/exams/" + d.exam_id, "_self");
          $('body').addClass('second-page');
          toolTip.transition()
            .duration(500)
            .style("opacity", 0);
        }
      });
  }
}
